import { render } from "./ChannelChoice.vue?vue&type=template&id=7f2e388c&scoped=true"
import script from "./ChannelChoice.vue?vue&type=script&lang=js"
export * from "./ChannelChoice.vue?vue&type=script&lang=js"

import "./ChannelChoice.vue?vue&type=style&index=0&id=7f2e388c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2e388c"]])

export default __exports__